import { StyledRequirementsEvolutionGraphic } from './RequirementsEvolutionGraphic.styled';

const RequirementsEvolutionGraphic = ({
  dataMilestone
}: {
  dataMilestone?: number;
}) => {
  return (
    <StyledRequirementsEvolutionGraphic
      width="610"
      height="610"
      viewBox="0 0 610 610"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-milestone={dataMilestone}
    >
      <circle
        cx="305"
        cy="305"
        r="304"
        fill="url(#paint0_radial)"
        stroke="#EBE8DF"
        strokeLinecap="round"
        strokeDasharray="24 24"
      />
      <circle
        cx="305"
        cy="305"
        r="208"
        fill="white"
        fillOpacity="0.25"
        stroke="#EBE8DF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="305"
        cy="305"
        r="144"
        fill="url(#paint1_radial)"
        stroke="#EBE8DF"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M305 97C341.477 97 377.312 106.593 408.911 124.815L376.937 180.258C355.062 167.643 330.253 161.002 305 161.002L305 97Z"
        fill="transparent"
        stroke="#DED9CC"
        strokeWidth="2"
        strokeLinecap="round"
        className="month1"
      />
      <path
        d="M408.876 124.795C440.531 143.042 466.821 169.306 485.1 200.942C503.379 232.579 513.002 268.472 513 305.01L448.998 305.007C449 279.712 442.338 254.863 429.683 232.961C417.029 211.059 398.828 192.877 376.914 180.244L408.876 124.795Z"
        fill="transparent"
        stroke="#DED9CC"
        strokeWidth="2"
        strokeLinecap="round"
        className="month3"
      />
      <path
        d="M513 305C513 332.315 507.62 359.362 497.167 384.598C486.714 409.834 471.393 432.764 452.078 452.078C432.764 471.393 409.834 486.714 384.598 497.167C359.362 507.62 332.315 513 305 513L305 449.006C323.911 449.006 342.637 445.281 360.109 438.044C377.58 430.807 393.455 420.199 406.827 406.827C420.199 393.455 430.807 377.58 438.044 360.109C445.281 342.637 449.006 323.911 449.006 305H513Z"
        fill="transparent"
        stroke="#DED9CC"
        strokeWidth="2"
        strokeLinecap="round"
        className="month6"
      />
      <path
        d="M305 449C384.529 449 449 384.529 449 305C449 225.471 384.529 161 305 161"
        stroke="#353241"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <g filter="url(#filter0_dd)">
        <circle cx="305" cy="305" r="100" fill="url(#paint2_angular)" />
        <circle cx="305" cy="305" r="100" stroke="#EBE8DF" strokeWidth="4" />
      </g>
      <path d="M293 449L305 442.072L305 455.928L293 449Z" fill="#353241" />
      <circle
        cx="510"
        cy="191"
        r="3"
        fill="#DED9CC"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="69"
        cy="161"
        r="5.5"
        fill="#EBE8DF"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="115"
        cy="441"
        r="5.5"
        fill="#EBE8DF"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="233"
        cy="403"
        r="7.5"
        fill="#C4B9A7"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="509"
        cy="117"
        r="5.5"
        fill="#EBE8DF"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="55"
        cy="216"
        r="3"
        fill="#AA9987"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="123"
        cy="292"
        r="3"
        fill="#AA9987"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="113"
        cy="175"
        r="3"
        fill="#DED9CC"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="167"
        cy="481"
        r="3"
        fill="#5A443D"
        stroke="white"
        strokeWidth="2"
      />
      <defs>
        <filter
          id="filter0_dd"
          x="171"
          y="171"
          width="268"
          height="268"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.14902 0 0 0 0 0.101961 0 0 0 0 0.0980392 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.14902 0 0 0 0 0.101961 0 0 0 0 0.0980392 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow"
            result="effect2_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(305 305) rotate(90) scale(304)"
        >
          <stop offset="0.838542" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" stopOpacity="0.5" />
        </radialGradient>
        <radialGradient
          id="paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(305 305) rotate(90) scale(144)"
        >
          <stop offset="0.244792" stopColor="#8F7A6A" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_angular"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(305 305) rotate(90) scale(113.5)"
        >
          <stop stopColor="#F8F7F3" />
          <stop offset="0.739583" stopColor="#C4B9A7" />
          <stop offset="1" stopColor="#5A443D" />
        </radialGradient>
      </defs>
    </StyledRequirementsEvolutionGraphic>
  );
};

export default RequirementsEvolutionGraphic;
